'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'tv-retro';
var width = 512;
var height = 512;
var aliases = [128250];
var unicode = 'f401';
var svgPathData = ['M32 128l448 0 0 320-448 0 0-320zm32 32l0 256 288 0 0-256-288 0zm328 72a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm0 80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z', 'M160-6.6L256 89.4 340.7 4.7 352-6.6 374.6 16 363.3 27.3 294.6 96 512 96 512 480 0 480 0 96 217.4 96 148.7 27.3 137.4 16 160-6.6zM32 128l0 320 448 0 0-320-448 0zm384 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM392 312a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 192l0 192 224 0 0-192-224 0zM64 160l288 0 0 256-288 0 0-256z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTvRetro = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;